import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';

import { TableRow, TableRowColumn } from 'material-ui/Table';
import IconButton from "material-ui/IconButton";
import DeleteDialog from '../Common/DeleteDialog';

import EditIcon from "material-ui/svg-icons/editor/mode-edit";

class ReportScheduleTableRow extends Component {
    render() {
        const { row, children } = this.props;

        return (
            <TableRow key={row.name}>
                {children && children[0]}
                <TableRowColumn><Link to={`/dashboard/reports/schedule/${row.id}`}>{row.name}</Link></TableRowColumn>
                <TableRowColumn><Link to={`/dashboard/report/${row.reportId}`}>{row.reportName}</Link></TableRowColumn>
                <TableRowColumn>{row.schedule}</TableRowColumn>
                <TableRowColumn>1 {row.repeatInterval}</TableRowColumn>
                <TableRowColumn>{moment(row.dateAdded).format('dddd DD MMMM YYYY')}</TableRowColumn>
                <TableRowColumn>{row.recipients.join(', ')}</TableRowColumn>
                <TableRowColumn>{this.getActions()}</TableRowColumn>
            </TableRow>
        );
    }

    getActions() {
        return [
            <IconButton
                key="edit"
                tooltip="Edit"
                onClick={() => this.props.actions.onEdit(this.props.row)}
            >
                <EditIcon/>
            </IconButton>,
            <DeleteDialog
                title="Delete schedule"
                message="Are you sure you wish to delete this schedule?"
                value={this.props.row.id}
                onDelete={this.props.actions.onDelete}
                type="icon"
            />
        ];
    }
}

ReportScheduleTableRow.propTypes = {
    row: PropTypes.shape({
        id:             PropTypes.number.isRequired,
        name:           PropTypes.string,
        reportName:     PropTypes.string,
        time:           PropTypes.string,
        repeatInterval: PropTypes.string,
        lastRun:        PropTypes.string,
        recipients:     PropTypes.arrayOf(PropTypes.string)
    }),
    actions: PropTypes.object
}

export default ReportScheduleTableRow;
